exports.setImmediate = (cb, ...args) => setTimeout(cb, ...args, 0);
